module.exports = __webpack_public_path__ + "static/media/logo-11.79d7a2a8.jpg";